import { render, staticRenderFns } from "./DeliveryExpress.vue?vue&type=template&id=0f7d84f8&scoped=true&"
import script from "./DeliveryExpress.vue?vue&type=script&lang=js&"
export * from "./DeliveryExpress.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryExpress.vue?vue&type=style&index=0&id=0f7d84f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d84f8",
  null
  
)

export default component.exports